<script>
import { getAllWhatDosFromDbase } from '@/services/WhatDoServices';
import WhatDoWheel from './WhatDoWheel.vue';   // adjust path if needed

export default {
  components: { WhatDoWheel },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      allWhatDos: null,
      // selected whatDo
      selectedWhatDoId: null,
      selectedWhatDo: null,

    };
  },
  computed: {
    currentWhatDo() {
      console.log('*** the value of currentWhatDo is ***', this.selectedWhatDoId, this.selectedWhatDo);
      return this.selectedWhatDo || {};
    },
    metaWheelObject() {
      return {
        title: `Which whatDo Wheel Should I Spin?`,
        description: `Don't know where to start? Spin this wheel, to tell you which whatDo wheel to spin. That'll tell you what project to work on. Do it to it. Giterdone.`,
        projects: Object.values(this.allWhatDos).map( whatDo => ({ title: whatDo.title }) ) || [],
      };
    },
  },
  methods: {
    selectWhatDo(id) {
      window.scrollTo({ top: 187, behavior: "smooth" });
      this.selectedWhatDoId = id;
      this.selectedWhatDo = id === 'meta-wheel-of-wheels' ? this.metaWheelObject : this.allWhatDos[id];
    },
    goBackToList() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.selectedWhatDoId = null;
      this.selectedWhatDo = null;
    },
    expandAllWhatDosProjectsAccordions() {
      document.querySelectorAll('.whatdo-one-wheel-accordion-title').forEach(element => element.click());
    },
  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, behavior: "smooth" });

    const w = await getAllWhatDosFromDbase(this.uId, this.token);
    if (w) {
      this.allWhatDos = w;
    }
    console.log('*** all whatDo wheels from dbase ***', w);
  },
}
</script>

<template>
  <div id="page-whatdo" class="pt-2 pb-16 px-4">

    <!-- Page Header -->
    <div id="whatdo-page-header" class="mb-8 px-4">
      <div class="d-flex justify-end">
        <router-link to="/whatdo/new" class="text-right text-body-2 font-italic text-decoration-none text-green-darken-1">
          Create a new whatDo wheel
        </router-link>
      </div>

      <h1 class="text-center">whatDo?</h1>

      <p class="my-2 text-body-2 font-italic">
        No more thumb-twiddling. Spin the wheel to randomly select what to work on Right Now.
      </p>
      <p class="my-2 text-body-2 font-italic">
        <b>The whatDo wheel landed on one thing, but in your heart you want to work on another thing?? </b>
        <u>Good!</u> &nbsp;Do It To It. Go Do It <u>Now</u>.
      </p>
    </div> <!-- end page-header -->



    <!-- CARDS -->
    <v-row v-if="!selectedWhatDoId && allWhatDos" class="mb-6">
      <v-col cols="12">
        <p @click.prevent="expandAllWhatDosProjectsAccordions"
           class="text-right cursor-pointer font-italic text-body-2"
        >Expand/Close All Wheels</p>
      </v-col>

      <!-- META WHEEL OF WHATDO WHEELS -->
      <v-col cols="6">
        <div class="list-item-single-whatdo meta-wheel-of-wheels border-solid pa-2 d-flex flex-column justify-space-between">

          <div @click="selectWhatDo('meta-wheel-of-wheels')" class="flex-grow-1 cursor-pointer">
            <h3 class="my-2 text-red-darken-1 text-center text-capitalize">{{ metaWheelObject.title }}</h3>
            <p class="ma-2 text-body-2 text-grey-darken-1 font-italic">
              {{ metaWheelObject.description }}
            </p>
          </div>

          <div>
            <div class="mb-4 d-flex justify-center">
              <v-btn @click="selectWhatDo('meta-wheel-of-wheels')"
                     class="decorative-btn text-white text-capitalize"
                     color="green-lighten-2"
                     density="compact"
              >Spin This whatDo Wheel</v-btn>
            </div>

            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-title color="grey-lighten-4" class="whatdo-one-wheel-accordion-title">
                  {{ metaWheelObject.projects?.length || 0 }} projects
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <ul class="ms-2 mb-4">
                    <li v-for="(project, i) in metaWheelObject?.projects" :key="i"
                        class="mt-2 text-capitalize"
                    >{{ project.title }}</li>
                  </ul>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

        </div>
      </v-col>
      <!-- USER'S WHATDO WHEELS -->
      <v-col v-for="id of Object.keys(allWhatDos)" :key="id" cols="6">
        <div class="list-item-single-whatdo border-solid pa-2 d-flex flex-column justify-space-between">

          <div @click="selectWhatDo(id)" class="flex-grow-1 cursor-pointer">
            <h3 class="my-2 text-center text-uppercase">{{ allWhatDos[id].title }}</h3>
            <p class="ma-2 text-body-2 text-grey-darken-1 font-italic">
              {{ allWhatDos[id].description }}
            </p>
          </div>

          <div>
            <div class="mb-4 d-flex justify-center">
              <v-btn @click="selectWhatDo(id)"
                     class="decorative-btn text-white text-capitalize"
                     color="green-lighten-2"
                     density="compact"
              >Spin This whatDo Wheel</v-btn>
            </div>

            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-title color="grey-lighten-4" class="whatdo-one-wheel-accordion-title">
                  {{ allWhatDos[id]?.projects?.length || 0 }} projects
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <ul class="ms-2 mb-4">
                    <li v-for="(project, i) in allWhatDos[id]?.projects" :key="i"
                        class="mt-2 text-capitalize"
                    >{{ project.title }}</li>
                  </ul>
                  <router-link :to="`/whatdo/${id}`"
                               class="text-body-2 text-red-lighten-1 text-decoration-none"
                  ><i>Edit this wheel</i></router-link>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

        </div>
      </v-col>
    </v-row> <!-- end list VIEW -->


    <!-- WHEEL -->
    <div v-else>
      <div class="mb-4 d-flex justify-center">
        <v-btn @click.prevent="goBackToList"
               color="red-lighten-2"
               variant="outlined"
               density="comfortable"
               class="mb-8"
        >← Back to all wheels</v-btn>
      </div>

      <div class="text-center mb-12">
        <h2 class="text-h5 text-uppercase">{{ currentWhatDo.title }}</h2>
        <p class="text-body-2 font-italic">{{ currentWhatDo.description }}</p>
        <router-link :to="`/whatdo/${selectedWhatDoId}`"
                     class="text-body-2 text-red-lighten-1 text-decoration-none"
        ><i>Edit this wheel</i></router-link>
      </div>

      <!-- Pure Canvas Wheel -->
      <WhatDoWheel :what-do="currentWhatDo" />

      <div class="my-4 d-flex justify-center">
        <v-btn @click.prevent="goBackToList"
               color="red-lighten-2"
               variant="outlined"
               density="comfortable"
               class="mb-8"
        >← Back to all wheels</v-btn>
      </div>
    </div> <!-- end WHEEL VIEW -->

  </div>
</template>

<style scoped lang="scss">
#page-whatdo {
  min-height: 100vh;
  max-width: 700px;
  margin: 0 auto;

  .cursor-pointer { cursor: pointer; }


  .list-item-single-whatdo.meta-wheel-of-wheels {
    border-color: red;
  }
  .list-item-single-whatdo {
    border-radius: 20px;
    min-height: 300px;
    @media screen and (min-width: 768px) {
      min-height: 256px;
    }

    .decorative-btn {
      height: auto !important;
      min-height: 36px;
    }
    :deep(.v-btn__content) {
      white-space: normal !important;
      word-break: break-word;
    }

  }
}
</style>
